import PropTypes from 'prop-types';
import imageModel from 'models/imageModel';

export default {
  propTypes: PropTypes.shape({
    text: PropTypes.string,
    image: imageModel.propTypes,
    positionX: PropTypes.number,
    positionY: PropTypes.number,
    textPosition: PropTypes.string,
    textAlign: PropTypes.string,
    imageSize: PropTypes.string,
    imageSizeByHeight: PropTypes.string,
    textWidthSmall: PropTypes.bool
  }),

  default: {
    text: '',
    image: imageModel.default,
    positionX: 0,
    positionY: 0,
    textPosition: '',
    textAlign: '',
    imageSize: '',
    imageSizeByHeight: '',
    textWidthSmall: false
  }
};
